
/* User defined models */
export class Month {
  name: string;

  constructor(i: number) {
    this.name = ((i < 10 ? '0' : '') + i).toString();
  }
}
